import './ChiSiamo.css';

function ChiSiamo() {
    return (
        <div className='chisiamo-container'>
            <h1 className='chisiamo-title'>Associazione Settemotivi - ODV</h1>

            <p className='chisiamo-justify'>
                L'Associazione Settemotivi – ODV è nata il giorno 11 novembre del 2020. Ha la sua sede legale
                presso la Casa del Volontariato Socio Sanitario e AMA, in via L. De Paoli n. 19.
            </p>
            <p className='chisiamo-justify'>
                E' Iscritta al RUNTS repertorio n. 56893 del 17/10/2022 (già n. 1367 del Registro delle O.d.V.
                Regione Friuli Venezia Giulia)
            </p>
            <p className='chisiamo-justify'>
                Ha iniziato subito a presentare progetti radiofonici, prodotti sia con il contributo della
                Regione VFG e che con i Comuni del Circondario, tra i quali
            </p>
            <ul className='chisiamo-justify chisiamo-indent'>
                <li>La voce dei volontari – Le associazioni del territorio si raccontano;</li>
                <li>Insieme per la salute on line;</li>
                <li>Donna – quando il tuo corpo ti tradisce – Il tumore al seno (in collaborazione con il CRO di Aviano);</li>
                <li>Locali storici del FVG – Una storia da raccontare.</li>
                <li>I cori di Pordenone</li>
            </ul>

            <p>Seppur giovanissima, vanta numerose e preziose collaborazioni con:</p>
            <ul className='chisiamo-justify chisiamo-indent'>
                <li>L'Usci del FVG (Unione Regionale dei cori del Friuli Venezia Giulia);</li>
                <li>L'Oppure – una associazione di giovani che raccontano con professionalità il territorio;</li>
                <li>Alessandro ANESE – Consulente finanziario e patrimoniale di Pordenone;</li>
                <li>Prendersi cura – associazione socio sanitario in campo della oncologia;</li>
                <li>Informare per aiutare – Comunicazione sociale della Casa del Volontariato Socio Sanitario e AMA;</li>
                <li>Giacinto BEVILACQUA, giornalista sportivo e titolare della Casa Editrice "Alba Edizioni".</li>
            </ul>

            <p>
                E' media partner dell'Associazione Coro Polifonico S. Antonio Abate – ODV, per la trasmissione
                in streaming o in differita, degli eventi prodotti da quest'ultima e diffusi dalla radio digitale
                Radio Cosmo.
            </p>

            <p>Attualmente produce per Radio Cosmo le sottonotate rubriche:</p>
            <ul className='chisiamo-justify chisiamo-indent'>
                <li>Buongiorno! Bell'anime – dediche e richieste, condotto da Maurizio Nicastro;</li>
                <li>Di sana salute – informazione sulla salute condotta dal dott. Rosario ALBANESE;</li>
                <li>Econo-mia tua e di tutta – condotta dal dott. Alessandro ANESE;</li>
                <li>Un calcio alla moviola – i protagonisti dello sport locale condotta da Giacinto BEVILACQUA;</li>
                <li>A spasso con Clara – il territorio circostante raccontato da Clara CESA;</li>
                <li>La mia storia, il mio lavoro – l'economia (e non solo) del territorio raccontato da ospiti in studio, condotto da Lorella SANTAROSSA;</li>
                <li>Open Space – Spazio alla musica – gli artisti ospiti nello studio di Radio Cosmo si raccontano e si esibiscono live. Conducono Lorella Santarossa e Maurizio Nicastro;</li>
                <li>Serial K – condotto dalla nostra criminologa Erika Taschini;</li>
                <li>My life in music – dove il buon "Ciga" ci porta nel suo mondo musicale;</li>
                <li>Music Generation – con Raffaelle Schirato, dallo studio di Bassano del Grappa ci imerge nella musica più disparata;</li>
                <li>Degustibus – programma di ricette per il giorno dopo con la voce di Samatha Rigato.</li>
            </ul>
        </div>
    );
}

export default ChiSiamo;
